<template>
  <b-navbar toggleable="md" type="dark" variant="info" id="navbar" :style="{ '--environment-color-background': environment_color_background }">
    <b-navbar-brand ><a target="_new" href="https://www.initekconsulting.com/fleet-integrations"><img style="margin-top:-5px" width="40" src="favicon-white.png"/></a> Fleet Integrations</b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav :style="{ '--environment-color-button': environment_color_button }">

        <template v-if="tenant_type =='FASTTRAK'">
          <b-nav-item :to="{ name: 'dashboard' }">Dashboard</b-nav-item>
          <b-nav-item :to="{ name: 'vehicle_map' }">Map</b-nav-item>
          <b-nav-item :to="{ name: 'vehicle_trip_history' }">Trips</b-nav-item>
          <b-nav-item :to="{ name: 'actuals_fasttrak' }">Bookings</b-nav-item>
          <b-nav-item :to="{ name: 'alert_list' }">Alerts</b-nav-item >
          <b-nav-item :to="{ name: 'vehicle_status_dvir_fasttrak' }">VSM</b-nav-item>
        </template>

        <template v-if="tenant_type =='FLEET'">
          <b-nav-item :to="{ name: 'dashboard' }">Dashboard</b-nav-item>
          <b-nav-item :to="{ name: 'vehicle_map' }">Fleet Map</b-nav-item>
          <b-nav-item v-if="user.features[this.user.tenant].bus_sos_enabled" :to="{ name: 'sos_list' }">Bus SOS Manager</b-nav-item>
        </template>

        <template v-if="tenant_type =='CM-FLEET'">
          <b-nav-item :to="{ name: 'dashboard' }">Dashboard</b-nav-item>
          <b-nav-item :to="{ name: 'vehicle_map' }">Fleet Map</b-nav-item>
          <b-nav-item-dropdown  id="nav-dpdwn">
            <template slot="button-content">Reports</template>
            <b-dropdown-item :to="{ name: 'vehicle_route_history' }">Route History</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'route_assignments' }">Route Assignments</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'route_addresses' }">Route Addresses</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'report_otp' }">OTP - Nightly Report History</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'otp_history' }">OTP - Results History</b-dropdown-item>
          </b-nav-item-dropdown>
        </template>

        <template v-if="tenant_type =='CM' && (user.role == 'dispatch' || user.role == 'garage' || user.role == 'wash-bay')">
          <b-nav-item :to="{ name: 'vehicle_map' }">Fleet Map</b-nav-item>
          <b-nav-item v-if="user.features[this.user.tenant].vehicle_status_management_dvir_enabled" :to="{ name: 'vehicle_status_dvir' }">Vehicle Status Manager</b-nav-item>
          <b-nav-item v-else-if="user.features[this.user.tenant].vehicle_status_management_enabled" :to="{ name: 'vehicle_status' }">Vehicle Status Manager</b-nav-item>
          <b-nav-item v-if="user.role == 'dispatch' && user.features[this.user.tenant].alerts_enabled" :to="{ name: 'group_message_sender' }">Group Message Sender</b-nav-item>
        </template>

        <template v-if="tenant_type =='CM' && (user.role == 'garage')">
          <b-nav-item-dropdown  id="nav-dpdwn">
            <template slot="button-content">Reports</template>
            <b-dropdown-item :to="{ name: 'planned_vehicle_weekly' }">Vehicle Utilization Weekly</b-dropdown-item>
          </b-nav-item-dropdown>
        </template>

        <template v-else-if="tenant_type =='CM' && user.role == 'driver'">
          <b-nav-item :to="{ name: 'vehicle_map' }">Fleet Map</b-nav-item>
          <b-nav-item :to="{ name: 'trip_sheet' }">Vehicle Departure Board</b-nav-item>
        </template>

        <template v-else-if="tenant_type =='CM' && user.role == 'customer-care'">
          <b-nav-item :to="{ name: 'vehicle_map' }">Fleet Map</b-nav-item>
<!--          <b-nav-item :to="{ name: 'vehicle_trip_history' }">Vehicle Trip History</b-nav-item>-->
          <b-nav-item v-if="telematics_type=='SAMSARA'" :to="{ name: 'vehicle_route_history' }">Vehicle Route History</b-nav-item>
        </template>

        <template v-else-if="tenant_type =='CM' && user.role == 'manager'">
          <b-nav-item :to="{ name: 'vehicle_map' }">Fleet Map</b-nav-item>
          <b-nav-item-dropdown id="nav-dpdwn" v-if="user.features[this.user.tenant].views_reports_enabled" >
            <template slot="button-content">Reports</template>
            <b-dropdown-item :to="{ name: 'actuals_driver_payroll_report' }">Driver Daily Report</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'actuals_driver_multiday_report' }">Driver Multiday Report</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-if="user.features[this.user.tenant].vehicle_status_management_dvir_enabled" :to="{ name: 'vehicle_status_dvir' }">VSM</b-nav-item>
          <b-nav-item v-else-if="user.features[this.user.tenant].vehicle_status_management_enabled" :to="{ name: 'vehicle_status' }">VSM</b-nav-item>
          <b-nav-item v-if="user.features[this.user.tenant].alerts_enabled" :to="{ name: 'group_message_sender' }">Group Message Sender</b-nav-item>
        </template>

        <template v-else-if="tenant_type =='CM'">

          <b-nav-item :to="{ name: 'dashboard' }">Dashboard</b-nav-item>

          <b-nav-item-dropdown id="nav-dpdwn" >
            <template slot="button-content">Maps</template>
            <b-dropdown-item :to="{ name: 'vehicle_map' }">Fleet Map</b-dropdown-item>
            <b-dropdown-item v-if="user.role == 'admin'" :to="{ name: 'vehicle_map_future' }">Future Map</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'vehicle_trip_history' }">Vehicle Trip History</b-dropdown-item>
            <b-dropdown-item v-if="telematics_type=='SAMSARA'" :to="{ name: 'vehicle_route_history' }">Vehicle Route History</b-dropdown-item>
            <b-dropdown-item :to="{ path: '/booking-track/' + this.user.tenant }">Vehicle Booking Map</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item :to="{ name: 'actuals' }">Bookings</b-nav-item>
          <b-nav-item :to="{ name: 'alert_list' }">Alerts</b-nav-item >
          <b-nav-item v-if="user.features[this.user.tenant].vehicle_status_management_maint_enabled" :to="{ name: 'vehicle_status_maint' }">VSM</b-nav-item>
          <b-nav-item v-else-if="user.features[this.user.tenant].vehicle_status_management_dvir_enabled" :to="{ name: 'vehicle_status_dvir' }">VSM</b-nav-item>
          <b-nav-item v-else-if="user.features[this.user.tenant].vehicle_status_management_enabled" :to="{ name: 'vehicle_status' }">VSM</b-nav-item>
          <b-nav-item v-if="user.role != 'admin' && user.features[this.user.tenant].vehicle_status_management_enabled && !user.features[this.user.tenant].views_reports_enabled"
                      :to="{ name: 'vehicle_status_history' }">VSM History</b-nav-item>

          <b-nav-item-dropdown id="nav-dpdwn" v-if="user.role == 'admin' || user.features[this.user.tenant].views_reports_enabled" >
            <template slot="button-content">Reports</template>

            <b-dropdown-item v-if="this.user.tenant == 'jeffersonlines-d637fdad'" :to="{ name: 'bus_tracker' }">Bus Tracker</b-dropdown-item>
            <b-dropdown-item v-if="this.user.tenant == 'jeffersonlines-d637fdad'" :to="{ name: 'arrivals_departures_board' }">Arrive/Depart Dashboard</b-dropdown-item>

            <b-nav-text v-if="user.features[this.user.tenant].actuals_enabled"><span style="color:steelblue; font-weight: bold;margin:5px">Actuals Based Reports</span></b-nav-text>

            <template v-if="user.features[this.user.tenant].actuals_enabled">
              <b-dropdown-item :to="{ name: 'actuals_perf_report' }">Daily OTP Report</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'actuals_multiday_otp_report' }">Multiday OTP Report</b-dropdown-item>
              <b-dropdown-item v-if="telematics_type == 'SAMSARA'" :to="{ name: 'hos_history_report' }">HOS Event History Report</b-dropdown-item>
              <b-dropdown-item v-if="telematics_type == 'SAMSARA'" :to="{ name: 'actuals_mileage_cm' }">Mileage Report Daily</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'actuals_mileage_by_booking_report' }">Mileage By Booking Report</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'actuals_billing_report' }">Billing Report</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'actuals_vehicle_report' }">Vehicle Start/Stop Report</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'actuals_driver_payroll_report' }">Driver Daily Report</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'actuals_driver_multiday_report' }">Driver Multiday Report</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'actuals_payroll_summary_report' }">Payroll Summary Report</b-dropdown-item>
            </template>

            <b-nav-text><span style="color:steelblue; font-weight: bold;margin:5px">Planned Data Based Reports</span></b-nav-text>

            <b-dropdown-item :to="{ name: 'planned_drivers_daily' }">Driver Utilization Daily</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'planned_vehicle_daily' }">Vehicle Utilization Daily</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'planned_vehicle_weekly' }">Vehicle Utilization Weekly</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'planned_vehicle_types_monthly' }">Vehicle Utilization Monthly</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'trip_sheet' }">Vehicle Departure Board</b-dropdown-item>
            <b-dropdown-item v-if="user.features[this.user.tenant].smart_dispatching_enabled" :to="{ name: 'smart_route_assignments' }">Smart Route Assignments</b-dropdown-item>

            <b-nav-text v-if="user.features[this.user.tenant].views_reports_otp_report_enabled"><span style="color:steelblue; font-weight: bold;">OTP Data Based Reports</span></b-nav-text>

            <template v-if="user.features[this.user.tenant].views_reports_otp_report_enabled">
              <b-dropdown-item :to="{ name: 'vehicle_route_history' }">Route History</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'route_assignments' }">Route Assignments</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'route_addresses' }">Route Addresses</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'report_otp' }">OTP - Nightly Report History</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'otp_history' }">OTP - Results History</b-dropdown-item>
            </template>

            <b-nav-text><span style="color:steelblue; font-weight: bold;margin:5px">Misc Reports</span></b-nav-text>

            <b-dropdown-item :to="{ name: 'report_unplanned_vehicle' }">Unplanned Vehicle Activity</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'report_unplanned_hos' }">Unplanned Driver Activity</b-dropdown-item>
            <b-dropdown-item v-if="user.features[this.user.tenant].vehicle_status_management_enabled" :to="{ name: 'vehicle_status_history' }">VSM History</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'event_notes_list' }">Event Notes History Report</b-dropdown-item >
            <b-dropdown-item v-if="user.features[this.user.tenant].views_reports_converter_enabled" :to="{ name: 'report_converter' }">Report Converter</b-dropdown-item>
            <b-dropdown-item v-if="user.features[this.user.tenant].vehicle_status_management_maint_summary_enabled" :to="{ name: 'vehicle_maint_summary' }">Vehicle Maintenance Summary</b-dropdown-item>

          </b-nav-item-dropdown>

        </template>

        <template v-if="tenant_type =='TBN' && (this.user.tenant.indexOf('parent') != -1)">
          <b-nav-item :to="{ name: 'vehicle_map' }">Fleet Map</b-nav-item>
          <b-nav-item-dropdown  id="nav-dpdwn" v-if="user.role == 'admin' || user.features[this.user.tenant].views_reports_enabled">
            <template slot="button-content">Reports</template>
            <b-dropdown-item :to="{ name: 'actuals_driver_payroll_report_tbn' }">Driver Daily Report</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'actuals_driver_multiday_report_tbn' }">Driver Multiday Report</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'event_notes_list' }">Event Notes History Report</b-dropdown-item>
          </b-nav-item-dropdown>
        </template>

        <template v-else-if="tenant_type =='TBN' && (user.role == 'dispatch' || user.role == 'garage' || user.role == 'wash-bay')">
          <b-nav-item :to="{ name: 'vehicle_map' }">Fleet Map</b-nav-item>
          <b-nav-item v-if="user.features[this.user.tenant].vehicle_status_management_dvir_enabled" :to="{ name: 'vehicle_status_dvir_tbn' }">Vehicle Status Manager</b-nav-item>
          <b-nav-item v-else-if="user.features[this.user.tenant].vehicle_status_management_maint_enabled" :to="{ name: 'vehicle_status_maint_tbn' }">Vehicle Status Manager</b-nav-item>
          <b-nav-item v-else-if="user.features[this.user.tenant].vehicle_status_management_enabled" :to="{ name: 'vehicle_status_tbn' }">Vehicle Status Manager</b-nav-item>
          <b-nav-item v-if="user.role == 'dispatch' && user.features[this.user.tenant].alerts_enabled" :to="{ name: 'group_message_sender_tbn' }">Group Message Sender</b-nav-item>
          <b-nav-item-dropdown id="nav-dpdwn" v-if="user.features[this.user.tenant].smart_dispatching_enabled" >
            <template slot="button-content">Dispatch Tools</template>
            <b-dropdown-item :to="{ name: 'vehicle_map_future' }">Future Map</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'driver_list_tbn' }">Smart Driver Mgmt</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'smart_route_assignments_tbn' }">Smart Route Assigner</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'trip_linker_report_tbn' }">Smart Trip Linker</b-dropdown-item>
          </b-nav-item-dropdown>
        </template>

        <template v-else-if="tenant_type =='TBN' && user.role == 'driver'">
          <b-nav-item :to="{ name: 'vehicle_map' }">Fleet Map</b-nav-item>
        </template>

        <template v-else-if="tenant_type =='TBN' && user.role == 'manager'">
          <b-nav-item :to="{ name: 'vehicle_map' }">Fleet Map</b-nav-item>
          <b-nav-item-dropdown id="nav-dpdwn" v-if="user.features[this.user.tenant].views_reports_enabled" >
            <template slot="button-content">Reports</template>
            <b-dropdown-item :to="{ name: 'actuals_driver_payroll_report_tbn' }">Driver Daily Report</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'actuals_driver_multiday_report_tbn' }">Driver Multiday Report</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item v-if="user.features[this.user.tenant].vehicle_status_management_dvir_enabled" :to="{ name: 'vehicle_status_dvir_tbn' }">VSM</b-nav-item>
          <b-nav-item v-else-if="user.features[this.user.tenant].vehicle_status_management_maint_enabled" :to="{ name: 'vehicle_status_maint_tbn' }">VSM</b-nav-item>
          <b-nav-item v-else-if="user.features[this.user.tenant].vehicle_status_management_enabled" :to="{ name: 'vehicle_status_tbn' }">VSM</b-nav-item>
          <b-nav-item v-if="user.features[this.user.tenant].vehicle_status_management_enabled" :to="{ name: 'vehicle_status_history' }">VSM History</b-nav-item>
          <b-nav-item v-if="user.features[this.user.tenant].alerts_enabled" :to="{ name: 'group_message_sender_tbn' }">Group Message Sender</b-nav-item>
        </template>

        <template v-else-if="tenant_type =='TBN'">

          <b-nav-item :to="{ name: 'dashboard' }">Dashboard</b-nav-item>

          <b-nav-item-dropdown id="nav-dpdwn" >
            <template slot="button-content">Maps</template>
            <b-dropdown-item :to="{ name: 'vehicle_map' }">Fleet Map</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'vehicle_trip_history' }">Vehicle Trip History</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'vehicle_route_history' }">Vehicle Route History</b-dropdown-item>
            <b-dropdown-item :to="{ path: '/booking-track/' + this.user.tenant + '?type=TBN' }">Vehicle Booking Map</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item :to="{ name: 'actuals_tbn' }">Bookings</b-nav-item>
          <b-nav-item :to="{ name: 'alert_list' }">Alerts</b-nav-item >
          <b-nav-item v-if="user.features[this.user.tenant].vehicle_status_management_dvir_enabled" :to="{ name: 'vehicle_status_dvir_tbn' }">VSM</b-nav-item>
          <b-nav-item v-else-if="user.features[this.user.tenant].vehicle_status_management_maint_enabled" :to="{ name: 'vehicle_status_maint_tbn' }">VSM</b-nav-item>
          <b-nav-item v-else-if="user.features[this.user.tenant].vehicle_status_management_enabled" :to="{ name: 'vehicle_status_tbn' }">VSM</b-nav-item>
          <b-nav-item v-if="user.role != 'admin' && user.features[this.user.tenant].vehicle_status_management_enabled && !user.features[this.user.tenant].views_reports_enabled"
                      :to="{ name: 'vehicle_status_history' }">VSM History</b-nav-item>

          <b-nav-item-dropdown id="nav-dpdwn" v-if="user.role == 'admin' || user.features[this.user.tenant].views_reports_enabled" >
            <template slot="button-content">Reports</template>

            <b-nav-text v-if="user.features[this.user.tenant].actuals_enabled"><span style="color:steelblue; font-weight: bold;margin:5px">Actuals Based Reports</span></b-nav-text>

            <template v-if="user.features[this.user.tenant].actuals_enabled">
              <b-dropdown-item :to="{ name: 'actuals_perf_report_tbn' }">Daily OTP Report</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'actuals_multiday_otp_report_tbn' }">Multiday OTP Report</b-dropdown-item>
              <b-dropdown-item v-if="telematics_type=='SAMSARA'" :to="{ name: 'actuals_mileage_tbn' }">Mileage Report Daily</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'actuals_billing_report_tbn' }">Pickup/Dropoff Report</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'actuals_start_events_report_tbn' }">Start Events Report</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'actuals_driver_payroll_report_tbn' }">Driver Daily Report</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'actuals_driver_multiday_report_tbn' }">Driver Multiday Report</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'actuals_payroll_summary_report_tbn' }">Payroll Summary Report</b-dropdown-item>
            </template>

            <b-nav-text><span style="color:steelblue; font-weight: bold;margin:5px">Planned Data Based Reports</span></b-nav-text>

            <b-dropdown-item :to="{ name: 'planned_drivers_daily_tbn' }">Driver Utilization Daily</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'planned_drivers_weekly_util_tbn' }">Driver Utilization Weekly</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'planned_drivers_weekly_dispatch_tbn' }">Driver Dispatch Weekly</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'planned_vehicle_daily_tbn' }">Vehicle Utilization Daily</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'planned_vehicle_weekly_tbn' }">Vehicle Utilization Weekly</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'planned_vehicle_types_monthly_tbn' }">Vehicle Utilization Monthly</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'trip_sheet_tbn' }">Vehicle Departure Board</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'dispatch_board_tbn' }">Booking Dispatch Board</b-dropdown-item>

            <b-nav-text v-if="user.features[this.user.tenant].views_reports_otp_report_enabled"><span style="color:steelblue; font-weight: bold;">OTP Data Based Reports</span></b-nav-text>

            <template v-if="user.features[this.user.tenant].views_reports_otp_report_enabled">
              <b-dropdown-item :to="{ name: 'vehicle_route_history' }">Route History</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'route_addresses' }">Route Addresses</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'report_otp' }">OTP - Nightly Report History</b-dropdown-item>
              <b-dropdown-item :to="{ name: 'otp_history' }">OTP - Results History</b-dropdown-item>
            </template>

            <b-nav-text><span style="color:steelblue; font-weight: bold;margin:5px">Misc Reports</span></b-nav-text>

            <b-dropdown-item v-if="user.features[this.user.tenant].vehicle_status_management_enabled" :to="{ name: 'vehicle_status_history' }">VSM History</b-dropdown-item>
            <b-dropdown-item v-if="this.user.tenant == 'mtrwestern-tbn-3db5da5g7'" :to="{ name: 'actuals_hours_by_client_report_tbn' }">Hours By Client Report</b-dropdown-item>
            <b-dropdown-item v-if="this.user.tenant == 'mtrwestern-tbn-3db5da5g7'" :to="{ name: 'actuals_hours_by_booking_report_tbn' }">Hours By Booking Report</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'event_notes_list' }">Event Notes History Report</b-dropdown-item >
            <b-dropdown-item :to="{ name: 'hos_history_report' }">HOS Event History Report</b-dropdown-item>
            <b-dropdown-item v-if="this.user.tenant == 'anderson-759g468f' || user.role == 'admin'" :to="{ name: 'intrastate_booking_report_tbn' }">Intrastate Booking Report</b-dropdown-item>
            <b-dropdown-item v-if="user.features[this.user.tenant].tbn_tyler_route_sync_enabled" :to="{ name: 'tyler_route_processor' }">Tyler Route Processor</b-dropdown-item >

          </b-nav-item-dropdown>

          <b-nav-item-dropdown id="nav-dpdwn" v-if="user.features[this.user.tenant].smart_dispatching_enabled" >
            <template slot="button-content">Dispatch Tools</template>
            <b-dropdown-item :to="{ name: 'vehicle_map_future' }">Future Map</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'driver_list_tbn' }">Smart Driver Mgmt</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'smart_route_assignments_tbn' }">Smart Route Assigner</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'trip_linker_report_tbn' }">Smart Trip Linker</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown id="nav-dpdwn" v-if="user.features[this.user.tenant].data_services_compare_drivers_enabled || user.role == 'admin'" >
            <template slot="button-content">Sync</template>
            <b-dropdown-item :to="{ name: 'compare_drivers' }">Compare Driver Lists</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'compare_driver_profiles' }">Compare Driver Profiles</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'compare_drivers_history' }">Compare Driver History</b-dropdown-item>
          </b-nav-item-dropdown>

        </template>

        <b-nav-item-dropdown v-if="user.role == 'admin' || user.role == 'customer-admin' || user.role == 'tbn-admin'" id="nav-user-dropdown">
          <template slot="button-content">Admin</template>
          <b-dropdown-item v-if="user.role == 'admin' || user.role == 'customer-admin' || user.role == 'tbn-admin'" :to="{ name: 'user_list' }">Manage Users</b-dropdown-item>
          <b-dropdown-item v-if="tenant_type =='CM' && user.features[this.user.tenant].smart_dispatching_enabled" :to="{ name: 'driver_list' }">Manage Drivers</b-dropdown-item>
          <b-dropdown-item v-if="user.role == 'admin' || user.features[this.user.tenant].bus_sos_enabled" :to="{ name: 'sos_list' }">Bus SOS Manager</b-dropdown-item>
          <b-dropdown-item v-if="tenant_type =='TBN' && user.features[this.user.tenant].alerts_enabled" :to="{ name: 'group_message_sender_tbn' }">Group Message Sender</b-dropdown-item>
          <b-dropdown-item v-if="tenant_type =='CM' && user.features[this.user.tenant].alerts_enabled" :to="{ name: 'group_message_sender' }">Group Message Sender</b-dropdown-item>
          <b-dropdown-item v-if="user.role == 'admin'" :to="{ name: 'admin_dashboard' }">Summary Dashboard</b-dropdown-item>
          <b-dropdown-item v-if="user.role == 'admin'" :to="{ name: 'process_manager_list' }">Process Manager</b-dropdown-item>
          <b-dropdown-item v-if="user.role == 'admin'" :to="{ name: 'tenant_manager' }">All Tenants</b-dropdown-item>
          <b-dropdown-item v-if="tenant_type =='CM'" :to="{ name: 'booking_file_list' }">Booking File History</b-dropdown-item >
          <b-dropdown-item v-if="user.role == 'admin'" :to="{ name: 'actuals_simulator' }">Actuals Simulator</b-dropdown-item >
        </b-nav-item-dropdown>

        <b-nav-item-dropdown v-if="user.role == 'admin' || user.role == 'customer-admin' || user.role == 'tbn-admin'">
          <template slot="button-content">Settings</template>
          <b-dropdown-item :to="{ name: 'tenant_config_general' }">General Settings</b-dropdown-item>
          <b-dropdown-item v-if="user.role == 'admin' || user.features[this.user.tenant].actuals_enabled" :to="{ name: 'tenant_config_bookings_actuals' }">Bookings & Actuals Settings</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'tenant_config_cust_map_views' }">Map Settings</b-dropdown-item>
          <b-dropdown-item v-if="user.role == 'admin' || user.features[this.user.tenant].views_reports_enabled" :to="{ name: 'tenant_config_views_reports' }">Views & Reports Settings</b-dropdown-item>
          <b-dropdown-item v-if="user.role == 'admin' || user.features[this.user.tenant].alerts_enabled" :to="{ name: 'tenant_config_alerts' }">Alerts Settings</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'tenant_config_notifications' }">Notifications Settings</b-dropdown-item>
          <b-dropdown-item v-if="user.role == 'admin' || user.features[this.user.tenant].vehicle_status_management_enabled" :to="{ name: 'tenant_config_veh_status_mgmt' }">Vehicle Status Manager Settings</b-dropdown-item>
          <b-dropdown-item v-if="user.role == 'admin' || user.features[this.user.tenant].bus_sos_enabled" :to="{ name: 'tenant_config_bus_sos' }">Bus SOS Settings</b-dropdown-item>
          <b-dropdown-item v-if="user.role == 'admin' || user.features[this.user.tenant].data_services_enabled" :to="{ name: 'tenant_config_data_services' }">Data Services Settings</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'tenant_config_history' }">Settings History</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item :to="{ name: 'support_ticket_list' }">Support</b-nav-item>

      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
          <span v-if="user.tenant_options.length > 0" class="d-flex align-items-center justify-content-center">
            <b-form-select class="nav-tabs nav-link" :style="{ '--environment-color-button': environment_color_button }" style="font-size: 20px; font-weight: bold" v-model="user.tenant" :options="user.tenant_options" @change="set_tenant_id"/>
          </span>
          <span v-else class="d-flex align-items-center justify-content-center" style="color:white; font-size: 22px; font-weight: bold;">
            {{user.tenant_name}}
          </span>

        <b-nav-item-dropdown right id="nav-user-dropdown" :style="{ '--environment-color-button': environment_color_button }">
          <template slot="button-content">{{`${user.username}`}}</template>
          <b-dropdown-item :to="{ path: 'user_detail?username=' + user.username}">Manage Profile</b-dropdown-item>
          <b-dropdown-item v-on:click.native="logout()" id="nav-log-out">Logout</b-dropdown-item>
        </b-nav-item-dropdown>

      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapState } from 'vuex'

import router from '../router'
export default {
  name: 'navbar',
  props: {
    authenticated: Boolean,
  },
  methods: {
    logout() {
      router.push("/login")
      this.$emit("authenticated", false);
    },
    set_tenant_id(id) {
      this.user.tenant = id
      localStorage.setItem('selected_tenant',id)
    },
  },
  computed:{
    ...mapState({
      user: state => state.profile.user,
    }),
    is_admin() {
      return this.user.role === 'admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    },
    environment_color_button() {
      return '#6095c1'
    },
    environment_color_background() {
      return 'steelblue'
    }
  }

}
</script>

<style>

.bg-info {
  background-color: var(--environment-color-background, steelblue) !important;
}

#navbar {
  background-color: var(--environment-color-background, steelblue) !important;
  padding: 1rem !important;
}

.nav-tabs {
  background-color: var(--environment-color-background, steelblue) !important;
}

.nav-link {
  background-color: var(--environment-color-button, #6095c1) !important;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 20px;
  font-weight: bold;
  color: white !important;
  margin-left: .8rem;
  justify-content: center !important;
  padding: .3rem !important;
}

.navbar-brand {
  color: white !important;
  font-size: 22px !important;
  font-weight: bold;
}

</style>
